import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GoalService } from '@EYN/components';
import { Observable } from 'rxjs/internal/Observable';
import { first, map } from 'rxjs/operators';

@Injectable()
export class CanAccessOverviewGuard implements CanActivate {
	constructor(private goalService: GoalService) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.goalService.withRouteConfig()
			.pipe(first(), map(([{ overviewRoute }, goal]) => {
				if (this.goalService.isGoalStarted(goal)) {
					console.warn(`CanAccessOverviewGuard: Plan is started. Redirecting to the overview`);
					this.goalService.gotToSummaryPage();
					return false;
				} else {
					console.warn(`CanAccessOverviewGuard: can access`);
					return true;
				}
			}));
	}
}
